module.exports = __webpack_public_path__ + "HeartHome-2szT8On.svg";